import withIsVisibleHOC from "@client/hocs/withIsVisible";
import React from "react";
import Cart from "../../FloatingMenu/CartItem/container";
import HeaderElement from "../Element/container";

export default withIsVisibleHOC(() => (
  <HeaderElement>
    <Cart />
  </HeaderElement>
));
